// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pn-0";